"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PartnerTermsAndConditionsSchema = void 0;
const zod_1 = require("zod");
exports.PartnerTermsAndConditionsSchema = zod_1.z.object({
    content: zod_1.z.string(),
    version: zod_1.z.string(),
});
//# sourceMappingURL=terms-and-conditions.js.map